export const UPDATE_STREAM_MARKER = "UPDATE_STREAM_MARKER";
export const UPDATE_STREAM_MARKER_COMPLETE = "UPDATE_STREAM_MARKER_COMPLETE";
export const DELETE_STREAM_MARKER = "DELETE_STREAM_MARKER";
export const DELETE_STREAM_MARKER_COMPLETE = "DELETE_STREAM_MARKER_COMPLETE";
export const SAVE_STREAM = "SAVE_STREAM";
export const SAVE_STREAM_COMPLETE = "SAVE_STREAM_COMPLETE";
export const DELETE_STREAM = "DELETE_STREAM";
export const DELETE_STREAM_COMPLETE = "DELETE_STREAM_COMPLETE";
export const GET_STREAMS = "GET_STREAMS";
export const GET_STREAMS_COMPLETE = "GET_STREAMS_COMPLETE";
export const INIT_STREAM_DATA = "INIT_STREAM_DATA";
export const INIT_STREAM_DATA_COMPLETE = "INIT_STREAM_DATA_COMPLETE";
export const GET_PROVIDER_SRC = "GET_PROVIDER_SRC";
export const GET_PROVIDER_SRC_COMPLETE = "GET_PROVIDER_SRC_COMPLETE";
export const TOGGLE_STREAM_OPEN = "TOGGLE_STREAM_OPEN";
export const SET_TIME_SKIP = "SET_TIME_SKIP";
export const RESET_TIME_SKIP = "RESET_TIME_SKIP";
export const SET_POPOUT_OPEN = "SET_POPOUT_OPEN";
export const SET_POPOUT_CLOSED = "SET_POPOUT_CLOSED";
export const SET_STREAM_EVENT_ID = "SET_STREAM_EVENT_ID";
